import { Collapse } from "antd";
import type { ReactNode, ComponentType, SVGProps } from "react";

export const collapseHeaderStyle = {
  color: "#556C75",
  padding: "8px 10px",
  borderTop: "1px solid rgba(0, 0, 0, 0.06)",
  borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
  background: "rgba(0, 0, 0, 0.02)",
  height: "40px",
};

export default function ExplanationCard({
  title,
  chatExplanation = true,
  Icon,
  iconColor,
  children,
}: {
  title: string;
  chatExplanation?: boolean;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  iconColor?: string;
  children: ReactNode;
}) {
  return (
    <Collapse
      ghost={chatExplanation}
      defaultActiveKey={["1"]}
      expandIconPlacement="end"
      className={chatExplanation ? "chat-collapse" : "bg-gray-50"}
      items={[
        {
          key: "1",
          label: (
            <div className={`flex items-center ${iconColor ?? ""}`}>
              <Icon />
              <p className="ml-2 font-bold text-[#2B4752]">{title}</p>
            </div>
          ),
          children,
          ...(chatExplanation && {
            styles: {
              header: collapseHeaderStyle,
            },
          }),
        },
      ]}
    />
  );
}
